const getBridge = () => {
	if (typeof window === 'undefined') return null;
	return window.ReactNativeWebView || window.reactnativewebview;
};

export const isBridgeMode = () => {
	const bridge = getBridge();
	return Boolean(bridge);
};

export const openLinkInBrowser = (url) => {
	const bridge = getBridge();
	if (!bridge || typeof bridge.postMessage !== 'function' || !url) return false;

	bridge.postMessage(
		JSON.stringify({
			action: 'openLinkInBrowser',
			url: url,
		}),
	);

	return true;
};

export const switchApp = () => {
	const bridge = getBridge();
	if (!bridge || typeof bridge.postMessage !== 'function') return false;

	bridge.postMessage(
		JSON.stringify({
			action: 'switchToApp',
			app: "spa",
		}),
	);

	return true;
}

const communicationBridge = {
	isBridgeMode,
	openLinkInBrowser,
	switchApp,
};

export default communicationBridge;
